import { render, staticRenderFns } from "./CustomerHausefulReceivedInvoices.vue?vue&type=template&id=0bfd3d1e&scoped=true&"
import script from "./CustomerHausefulReceivedInvoices.vue?vue&type=script&lang=js&"
export * from "./CustomerHausefulReceivedInvoices.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHausefulReceivedInvoices.vue?vue&type=style&index=0&id=0bfd3d1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd3d1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
